import React from 'react';
import { useTheme } from '../providers/ThemeProvider';
import MainLogo from '../assets/main_logo.svg';

interface DynamicLogoProps {
  /** Larghezza massima del logo */
  maxWidth?: string;
  /** Altezza massima del logo */
  maxHeight?: string;
  /** Classe CSS aggiuntiva */
  className?: string;
  /** Stile inline aggiuntivo */
  style?: React.CSSProperties;
  /** Funzione chiamata al click */
  onClick?: () => void;
  /** Alt text personalizzato */
  alt?: string;
}

/**
 * Componente per logo dinamico che si adatta automaticamente alle proporzioni
 * Mantiene le proporzioni originali del logo senza schiacciarlo
 */
export default function DynamicLogo({ 
  maxWidth = '150px', 
  maxHeight = '60px', 
  className = '', 
  style = {},
  onClick,
  alt
}: DynamicLogoProps) {
  const { logo, brandLabel, isConfigured } = useTheme();
  
  const logoSrc = isConfigured && logo ? logo : MainLogo;
  const logoAlt = alt || brandLabel || 'Logo';
  
  return (
    <img
      src={logoSrc}
      alt={logoAlt}
      className={`bg-contain cursor-pointer ${className}`}
      style={{
        maxWidth,
        maxHeight,
        width: 'auto',
        height: 'auto',
        objectFit: 'contain',
        ...style
      }}
      onClick={onClick}
    />
  );
}
